import { ok } from '@oazapfts/runtime';
import * as rq from '@tanstack/react-query';

import { FeApi, useInjectFeApiContext } from '@/api/fe-api';

export namespace DetachTaskMutation {
  export type Input = { id: string; workstreamId: string };
  export type Output = void;

  function useMutationFn() {
    const detachTask = useInjectFeApiContext(
      FeApi.tasksV1CardsDetachFromWorkstreamDestroy,
    );

    return async function mutationFn(input: Input) {
      await ok(
        detachTask({
          uuid: input.id,
        }),
      );
    };
  }

  export function useMutation() {
    const queryClient = rq.useQueryClient();
    const mutationFn = useMutationFn();

    return rq.useMutation<Output, unknown, Input>({
      mutationFn,
      async onSuccess() {
        await queryClient.invalidateQueries({
          queryKey: ['project-management'],
        });
      },
    });
  }
}
